// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__+gX17","secondary":"Link_secondary__IFKdQ"};